import { FC } from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import { Link as GLink, Icon, Widget, Typography } from '~ui'
import { FAN_PROMISE } from '../../../routes/paths'

import styles from './GrantedSecure.module.scss'

type GrantedSecureProps = {
  display?: 'desktop' | 'mobile' | 'all'
  withWidget?: boolean
  withPadding?: boolean
  text?: string
}
const GrantedSecure: FC<GrantedSecureProps> = ({
  display = 'desktop',
  withPadding = true,
  withWidget,
  text = 'Granted is a ticket marketplace that puts fans first. All tickets are protected by our',
}) => (
  <div className={classNames({ [styles[`display-${display}`]]: display })}>
    <Widget {...(withWidget && { borderColor: 'dividers', backgroundColor: 'elevated' })}>
      <div className={classNames(styles.wrapper, { [styles['wrapper-padding']]: withPadding })}>
        <Icon name="key-down" width={80} height={90} glow glowColor="green" />
        <div className={styles.content}>
          <span className={styles.title}>Granted Secure</span>
          <p className={styles.description}>
            {text}
            <GLink color="green" href={FAN_PROMISE}>
              &nbsp;Fan Promise.
            </GLink>
          </p>
        </div>
      </div>
    </Widget>
  </div>
)

const GrantedSecureBanner = () => (
  <div className={styles['mobile-wrapper']}>
    <Link legacyBehavior href={FAN_PROMISE}>
      <a className={styles['mobile-content']}>
        Tickets backed by the
        <span className={styles['mobile-link']}>
          &nbsp;Granted Fan Promise <Icon name="right-arrow-with-tail" width="1em" height="1em" />
        </span>
      </a>
    </Link>
  </div>
)

const GrantedSecureMobile = ({ text = 'All tickets backed by the' }) => (
  <Widget className={styles['widget-padding']} backgroundColor="elevated" borderColor="dividers">
    <Typography.Text center size="sm">
      {text}
      <GLink href={FAN_PROMISE} size="sm" color="g-green">
        &nbsp;Granted Fan Promise
      </GLink>
    </Typography.Text>
  </Widget>
)

export default GrantedSecure
export { GrantedSecureBanner, GrantedSecureMobile }
